export const STORE_TEST_ID: string = 'AddressTypeStore';
